import { createSelector } from 'reselect';

const selectMastersState = (state) => state.masters;

export const makeSelectMasterItems = (collectionName) =>
  createSelector(
    [selectMastersState],
    (mastersState) => mastersState.collections[collectionName] || []
  );